module.exports = __webpack_public_path__ + "img/chart.b8d8a1b0.svg";